import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'namesWithDash'
})
export class NamesWithDashPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/(^|-)(\S)/g, (character: string) => character.toUpperCase());
  }
}
